import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Typography } from '@material-ui/core';

import { InfoMessage, TopActionBar } from '../../common/components';
import urls from '../../app/urls';
import ResourceTaskContent from '../resource/components/ResourceTaskContent';
import apiUrls from '../../youwell-common/apiUrls';
import { PrintIcon } from '../../common/icons';

export const styles = theme => ({
    root: {
    },
    content: {
        minHeight: '80vh',
        padding: theme.spacing(2, 4),

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
        },
    },
    print: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',

        '@media print': {
            display: 'none',
        },
    },
    file: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        marginLeft: theme.spacing(1),
    },
    underline: {
        borderBottom: '1px solid',
    },
});

const Task = ({
    classes, translate, task, hasLoaded,
}) => {
    if (!task) {
        return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
    }

    return (
        <div className={classes.root}>
            <TopActionBar
                title={task.name}
                backLink={{
                    to: `${urls.inside.home}`,
                    text: translate('program.backToOverview'),
                }}
            />

            <div className={classes.content}>
                {task.printFileId && (
                    <div className={classes.print}>
                        <a href={`${apiUrls.baseUrl}/${apiUrls.media.file}/${task.printFileId}`} target="_blank" rel="noopener noreferrer">
                            <Typography className={classes.file}>
                                <span className={classes.underline}>
                                    {translate('page.clickToDownloadPrintfirendlyFile')}
                                </span>
                                <PrintIcon className={classes.icon} />
                            </Typography>
                        </a>
                    </div>
                )}

                <ResourceTaskContent
                    task={task}
                />
            </div>
        </div>
    );
};

Task.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    task: PropTypes.object,
};

Task.defaultProps = {
    task: null,
};

const mapStateToProps = (state, ownProps) => {
    const itemId = ownProps?.match?.params?.taskId;
    const task = itemId && state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules
        ?.reduce((prev, curr) => prev || curr.tasks?.find(d => d.id === itemId)
    , null);

    return {
        translate: getTranslate(state.localize),
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]),
        task,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(Task));
